export default __webpack_public_path__ + "static/media/user.e8de1442.svg";